<template>
  <div class="spoiler-mini">
    <div 
      class="spoiler-mini__wrapper"
      :class="{isActive: isActive}"
    >
      <button 
        class="spoiler-mini__title"
        @click="log"
      >
        <slot name="title">
          {{ props.title }}
          <IconDef name="arrow"/>
        </slot>
      </button>
      <div class="spoiler-mini__content">
          <div class="body">
            <slot name="content">
              {{props.content}}
            </slot>
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue"
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  content: {
    type: String,
    default: ''
  }
})

let isActive = ref(false)
const log = () => {
  isActive.value = !isActive.value
} 

</script>